import { DomainZone } from '../../core/types';

export const createVkDatingMaLink = (domainZone: DomainZone): string => {
  return `https://m.vk.${domainZone}/dating`;
};
